import { Checkbox, Stack, TextField } from "@mui/material";
import InputControl from "../../../shared/components/InputControl";
import { DashBoardDateRangePicker } from "../../Dashboard/components/DashBoardDateRangePicker";
import { FTI_STATUS_OPTIONS } from "../constants";

// The store filter is only rendered when `storeOptions` is given (super admin)
export const FullTaxInvoiceListFilterSection = ({
  filter,
  storeOptions = null,
  onFilterChange,
  onOpenDateRangeSelection,
  onDateChangeApply,
}) => {
  const { values } = filter;

  return (
    <Stack
      direction="row"
      gap="16px"
      alignItems="center"
      flexWrap="wrap"
      flex={1}
    >
      <InputControl
        type="dropdown"
        name="status"
        options={FTI_STATUS_OPTIONS}
        value={values.status}
        onChange={(_, value) => onFilterChange({ name: "status", value })}
        getOptionLabel={(option) => option.label}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        sx={{ width: 180 }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Status"
            placeholder="~ Select ~"
            InputLabelProps={{ ...params.InputLabelProps, shrink: true }}
          />
        )}
      />
      {storeOptions && (
        <InputControl
          type="dropdown"
          name="stores"
          multiple
          disableCloseOnSelect
          disableClearable
          options={storeOptions}
          value={values.stores}
          onChange={(_, value) => onFilterChange({ name: "stores", value })}
          getOptionLabel={(option) => option.label}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          renderTags={() => null}
          renderOption={(props, option, { selected }) => (
            <li {...props} key={option.value}>
              <Checkbox style={{ marginRight: 8 }} checked={selected} />
              {option.label}
            </li>
          )}
          sx={{ width: 250 }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Store"
              placeholder={
                values.stores.length > 0
                  ? `${values.stores.length} selected`
                  : "~ Select ~"
              }
              InputLabelProps={{ ...params.InputLabelProps, shrink: true }}
            />
          )}
        />
      )}
      <DashBoardDateRangePicker
        isList={true}
        range={filter.date.value}
        showRange={values.date_range}
        isOpen={filter.date.isCalenderOpen}
        handleIsOpen={onOpenDateRangeSelection}
        handleDateChangeApply={onDateChangeApply}
        position="left"
        onChangeDate={(event) => {
          onFilterChange({ name: "date_range", value: event });
        }}
        label="Date Range"
      />
    </Stack>
  );
};
